import userService from "../api/server/userService";
export const USERS_NAMESPACE = "usersModule";

var fakeService;
const loadFakeService = async () => {
  if (fakeService) return fakeService;
  return import(
    `../api/${process.env.VUE_APP_SERVICE_FOLDER}/userService`
  ).then(x => {
    fakeService = x.default;
    return fakeService;
  });
};

var services = {
  api:
    (process.env.VUE_APP_SERVICE_FOLDER === "fakes" &&
      process.env.NODE_ENV === "development") ||
    process.env.NODE_ENV === "test"
      ? loadFakeService()
      : Promise.resolve(userService)
};

const state = {
  loading: true,
  users: [],
  selectedUser: {},
  clients: []
};

const actions = {
  async checkUniqueUserName(context, userName) {
    var api = await services.api;
    return api.uniqueUserName(userName).then(response => {
      return response;
    });
  },
  selectUser(context, data) {
    return context.commit("SET_USER", data);
  },
  saveUser(context, data) {
    return context.commit("SAVE_USER", data);
  },
  async loadUsers(context, data) {
    context.state.loading = true;
    var api = await services.api;
    return api.load().then(response => {
      context.commit("SET_USER_LIST", response);
      context.state.loading = false;
    });
  },
  async loadClientList(context) {
    context.commit("SET_CLIENT_LIST", []);
    var api = await services.api;
    return api.loadClients().then(response => {
      context.commit("SET_CLIENT_LIST", response);
    });
  }
};

const mutations = {
  SET_USER(storeState, data) {
    storeState.selectedUser = data;
  },
  async SAVE_USER(storeState, data) {
    var api = await services.api;
    return api.save(data).then(res => {
      var index = -1;
      var updatedUser = data;
      updatedUser.Password = null;
      updatedUser.SendEmail = null;
      // -- splice in the modified user
      for (var i = 0; i < storeState.users.length; i++) {
        if (storeState.users[i].Id === updatedUser.Id) {
          index = i;
          break;
        }
      }
      if (index !== -1) {
        storeState.users.splice(index, 1, updatedUser);
      } else {
        storeState.users.push(updatedUser);
      }
      storeState.selectedUser = {};
    });
  },
  SET_USER_LIST(storeState, data) {
    storeState.users = data;
  },
  SET_CLIENT_LIST(storeState, data) {
    storeState.clients = data.sort(function(a, b) {
      return a.Name.toLowerCase() > b.Name.toLowerCase()
        ? 1
        : b.Name.toLowerCase() > a.Name.toLowerCase()
        ? -1
        : 0;
    });
    var client3 = storeState.clients.find(x => x.Id == 3);
    var client4 = storeState.clients.find(x => x.Id == 4);
    if (client3 && client4) {
      var locations = client3.Locations.concat(client4.Locations);
      storeState.clients.forEach(x => {
        if (x.Id == 3 || x.Id == 4) x.Locations = locations;
      });
    }
  }
};

const getters = {
  loading: storeState => storeState.loading,
  users: storeState => storeState.users,
  selectedUser: storeState => storeState.selectedUser,
  clients: storeState => storeState.clients
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  services
};
